import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { TextField } from "@material-ui/core";
import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { APARTMENTS_CONFIG, APARTMENTS_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import { fetchEditApartment } from "redux/actions/buildings/apartments/apartmentsActions";

const ApartmentsSchema = Yup.object({
  [APARTMENTS_CONFIG.customer.key]: Yup.string().required(
    getRequiredField(APARTMENTS_CONFIG.customer.label)
  ),
  [APARTMENTS_CONFIG.contract.key]: Yup.string().required(
    getRequiredField(APARTMENTS_CONFIG.contract.label)
  )
});

export const AssignContractForm = forwardRef(props => {
  const dispatch = useDispatch();
  const { handleClose } = props;
  const { editApartment } = useSelector(state => state.apartments);

  const {
    reset,
    register,
    handleSubmit,

    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(ApartmentsSchema)
  });

  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const onSubmit = React.useCallback(
    formData => {
      // You can use the validated data to make your API request here
      const body = {
        contract: formData[APARTMENTS_CONFIG.contract.key]
      };

      dispatch(fetchEditApartment(body, editApartment.id));
      handleCloseForm();
    },
    [editApartment]
  );

  useEffect(() => {
    if (editApartment) {
      if (editApartment.customer) {
        setValue(APARTMENTS_CONFIG.customer.key, editApartment.customer?.name);
      }
    }
  }, [editApartment]);

  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <TextField
          fullWidth
          type="text"
          disabled
          label={APARTMENTS_CONFIG.customer.label}
          variant="outlined"
          error={!!errors[APARTMENTS_CONFIG.customer.key]}
          helperText={errors[APARTMENTS_CONFIG.customer.key]?.message}
          {...register(APARTMENTS_CONFIG.customer.key)}
          size="small"
        />
        <TextField
          fullWidth
          type="text"
          label={APARTMENTS_CONFIG.contract.label}
          variant="outlined"
          error={!!errors[APARTMENTS_CONFIG.contract.key]}
          helperText={errors[APARTMENTS_CONFIG.contract.key]?.message}
          {...register(APARTMENTS_CONFIG.contract.key)}
          size="small"
        />
        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleCloseForm}
          >
            {APARTMENTS_PHRASE.contractModal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {APARTMENTS_PHRASE.contractModal.actions.assign}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
